import React from 'react';

interface IconLockProps {
    iconClasses?: string;
}

const IconLock: React.FC<IconLockProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-lock ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <rect
                x="1.5"
                y="7"
                width="11"
                height="7.5"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
            />
            <path
                d="M4 7V5a3 3 0 0 1 6 0v2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
            />
        </svg>
    );
};

export default IconLock;
